export default "__VITE_ASSET__DzmwC7p7__"